export const baseUrl = 'https://ksh.boyastem.com'

